module.exports = __webpack_public_path__ + "static/media/lateral-nonflexion-up-3.bb4dcce0.png";